import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";
import { eur, PAYMENT_METHODS } from "./docUtils";

const sel = "w-full border border-neutral-200 rounded-lg px-3 py-2 text-sm bg-white";

export default function PaymentModal({ invoice, onClose, onSaved }) {
  const reste = invoice ? Math.max(0, invoice.total_ttc - (invoice.paid_total || 0)) : 0;
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [method, setMethod] = useState("virement");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const amt = parseFloat(String(amount).replace(",", ".")) || 0;
    if (amt <= 0) { toast.error("Montant invalide"); return; }
    setLoading(true);
    try {
      const r = await api.post(`/accounting/invoices/${invoice.id}/payments`, { amount: amt, date, method });
      toast.success(r.data.status === "payee"
        ? "Facture soldée — merci !"
        : `Paiement enregistré — reste ${eur(r.data.total_ttc - r.data.paid_total)}`);
      onSaved();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={!!invoice} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="payment-modal" aria-describedby={undefined}>
        <DialogTitle className="font-heading font-bold text-lg">Enregistrer un paiement</DialogTitle>
        {invoice && (
          <div className="space-y-3 mt-2">
            <p className="text-sm text-neutral-500">
              Facture {invoice.number} — reste à payer : <strong className="text-neutral-900">{eur(reste)}</strong>
            </p>
            <div>
              <Label className="text-xs">Montant reçu (€)</Label>
              <Input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)}
                placeholder={reste.toFixed(2)} className="mt-1" data-testid="payment-amount" autoFocus />
            </div>
            <div>
              <Label className="text-xs">Date du paiement</Label>
              <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1" data-testid="payment-date" />
            </div>
            <div>
              <Label className="text-xs">Mode de paiement</Label>
              <select className={`${sel} mt-1`} value={method} onChange={(e) => setMethod(e.target.value)} data-testid="payment-method">
                {PAYMENT_METHODS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
            <Button onClick={submit} disabled={loading} className="w-full bg-green-600 hover:bg-green-700 text-white" data-testid="payment-submit">
              {loading ? "Enregistrement…" : "Enregistrer le paiement"}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
